(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[875],{

/***/ 9050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ AuthTest; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(5945);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./libs/next/api/jsonApiHandler.ts
var jsonApiHandler = __webpack_require__(3241);
;// CONCATENATED MODULE: ./app/data/Credentials.ts

const Credentials = lib.z.object({
    username: lib.z.string().email(),
    password: lib.z.string().min(6)
});
const SignupCredentials = lib.z.object({
    username: lib.z.string().email(),
    password: lib.z.string().min(6),
    nick: lib.z.string()
});

// EXTERNAL MODULE: ./app/hooks/useAuth.ts
var useAuth = __webpack_require__(1108);
// EXTERNAL MODULE: ./app/hooks/usePlanteeUser.ts
var usePlanteeUser = __webpack_require__(4481);
// EXTERNAL MODULE: ./app/utils/formDataFromEvent.tsx
var formDataFromEvent = __webpack_require__(845);
// EXTERNAL MODULE: ./app/components/AuthTest.module.sass
var AuthTest_module = __webpack_require__(6836);
var AuthTest_module_default = /*#__PURE__*/__webpack_require__.n(AuthTest_module);
// EXTERNAL MODULE: ./app/components/Buttons.tsx
var Buttons = __webpack_require__(2405);
// EXTERNAL MODULE: ./app/components/Input.tsx + 1 modules
var Input = __webpack_require__(3637);
;// CONCATENATED MODULE: ./app/components/AuthTest.tsx














const AuthTest = (props)=>{
    const plantee = (0,usePlanteeUser/* usePlanteeUser */.e)();
    const signedIn = (0,useAuth/* useIsSignedIn */.AN)();
    const router = (0,next_router.useRouter)();
    const locale = router.locale;
    const api = (0,jsonApiHandler/* createFetcher */.gt)("/api/auth/[handler]");
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const auth = (0,useAuth/* useAuth */.aC)();
    const [email, setEmail] = react.useState("");
    const [nick, setNick] = react.useState("");
    const [signUpStatus, setSignUpStatus] = react.useState("");
    react.useEffect(()=>{
        if (signedIn) {
            router.push("/");
        }
    }, [
        router,
        signedIn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (AuthTest_module_default()).wrapper,
        children: [
            !signedIn && !props.signUp && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: locale === "cs" ? "Přihl\xe1sit se" : "Log in"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        action: "",
                        method: "POST",
                        onSubmit: (e)=>{
                            e.preventDefault();
                            console.log("submit");
                            console.log((0,formDataFromEvent/* formDataFromEvent */.t)(e));
                            plantee.auth.signIn.mutate(Credentials.parse((0,formDataFromEvent/* formDataFromEvent */.t)(e)));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                            disabled: plantee.auth.signIn.isLoading,
                            style: {
                                opacity: plantee.auth.signIn.isLoading ? 0.5 : 1
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                    id: "username",
                                    name: "username",
                                    type: "email",
                                    required: true,
                                    iconDecoration: "pencil",
                                    label: {
                                        isLabel: true,
                                        icon: "user",
                                        text: locale === "cs" ? "E-mail" : "E-mail"
                                    },
                                    value: email,
                                    onChange: (e)=>{
                                        setEmail(e.currentTarget.value);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                    id: "password",
                                    name: "password",
                                    type: "password",
                                    required: true,
                                    label: {
                                        isLabel: true,
                                        icon: "lock",
                                        text: locale === "cs" ? "Heslo" : "Password"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    style: {
                                        color: "#d73a4a"
                                    },
                                    children: plantee.auth.signIn.error ? //@ts-ignore
                                    plantee.auth.signIn.error.message : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                                    type: "submit",
                                    fill: "green600",
                                    children: locale === "cs" ? "Přihl\xe1sit se" : "Log in"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        locale === "cs" ? "Ještě nem\xe1š \xfačet? " : "Do not have an account yet? You might want to ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                textDecoration: "underline"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/signup",
                                                children: locale === "cs" ? "Zaregistrovat se" : "Sign up"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        locale === "cs" ? "Zapomněl jsi heslo? " : "Forgot your password? You might want to ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                textDecoration: "underline"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: (AuthTest_module_default()).textButton,
                                                type: "button",
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    console.log(email);
                                                    if (email) {
                                                        auth.passwordReset.mutate({
                                                            email: email
                                                        }, {
                                                            onSuccess (data) {
                                                                const response = data;
                                                                if (response.message === "User has no ext." || response.statusCode === "404") {
                                                                    setSignUpStatus("User with this e-mail does not exist.");
                                                                }
                                                                if (response.statusCode === "200") {
                                                                    console.log("vv");
                                                                    setSignUpStatus("Password reset successfull please check your inbox");
                                                                } else {
                                                                    if (response.message) {
                                                                        setSignUpStatus(response.message);
                                                                    } else {
                                                                        setSignUpStatus("Password reset was not successful, please try again");
                                                                    }
                                                                }
                                                            }
                                                        });
                                                    } else {
                                                        setSignUpStatus("Please fill in email address in order to reset your password");
                                                    }
                                                },
                                                children: locale === "cs" ? "Obnovit heslo" : "reset your password"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            !signedIn && signUpStatus !== "signedUp" && props.signUp && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: locale === "cs" ? "Založen\xed \xfačtu" : "Sign up"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        className: (AuthTest_module_default()).signUpForm,
                        action: "",
                        method: "POST",
                        onSubmit: async (e)=>{
                            e.preventDefault();
                            const pass = (0,formDataFromEvent/* formDataFromEvent */.t)(e).password;
                            if (pass.length >= 8) {
                                await api("signUp", SignupCredentials.parse((0,formDataFromEvent/* formDataFromEvent */.t)(e))).then((res)=>{
                                    queryClient.invalidateQueries([
                                        "auth"
                                    ]);
                                    console.log(res);
                                    if (res.status && res.status === "signedUp") {
                                        setSignUpStatus("signedUp");
                                    }
                                    if (res.errorMessage) {
                                        setSignUpStatus(res.errorMessage);
                                    }
                                    return res;
                                });
                            } else {
                                setSignUpStatus("Password has to be at least 8 characters");
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                            disabled: plantee.auth.signUp.isLoading,
                            style: {
                                opacity: plantee.auth.signUp.isLoading ? 0.5 : 1
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                    id: "username",
                                    name: "username",
                                    type: "email",
                                    required: true,
                                    iconDecoration: "pencil",
                                    label: {
                                        isLabel: true,
                                        icon: "user",
                                        text: locale === "cs" ? "E-mail" : "E-mail"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                    id: "nick",
                                    name: "nick",
                                    type: "text",
                                    iconDecoration: "pencil",
                                    required: true,
                                    label: {
                                        isLabel: true,
                                        icon: "user",
                                        text: locale === "cs" ? "Přezd\xedvka" : "Nickname"
                                    },
                                    value: nick,
                                    onChange: (e)=>{
                                        setNick(e.currentTarget.value);
                                    },
                                    explanation: "We need you to choose a public username, so you can comment on Planteebase and create plant profiles."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                    id: "password",
                                    name: "password",
                                    type: "password",
                                    required: true,
                                    label: {
                                        isLabel: true,
                                        icon: "lock",
                                        text: locale === "cs" ? "Heslo" : "Password"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                                    type: "submit",
                                    fill: "green600",
                                    children: locale === "cs" ? "Zaregistrovat se" : "Sign up"
                                })
                            ]
                        })
                    })
                ]
            }),
            signUpStatus === "signedUp" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: locale === "cs" ? "Založen\xed \xfačtu proběhla \xfaspěšně, zkontrolujte e-mailovou schr\xe1nku a aktivujte śvůj \xfačet." : "Sign up successfull, check your email for account activation."
                })
            }),
            signUpStatus.length > 0 && signUpStatus !== "signedUp" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    style: {
                        color: "#d73a4a"
                    },
                    children: signUpStatus
                })
            }),
            signedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                action: "",
                method: "POST",
                onSubmit: (e)=>{
                    e.preventDefault();
                    plantee.auth.signOut.mutate();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("fieldset", {
                    disabled: plantee.auth.signOut.isLoading,
                    style: {
                        opacity: plantee.auth.signOut.isLoading ? 0.5 : 1
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "submit",
                        children: "signOut"
                    })
                })
            }),
            signedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                action: "",
                method: "POST",
                onSubmit: (e)=>{
                    e.preventDefault();
                    plantee.changeNick.mutate(lib.z.object({
                        nick: lib.z.string()
                    }).parse((0,formDataFromEvent/* formDataFromEvent */.t)(e)));
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                    disabled: plantee.changeNick.isLoading,
                    style: {
                        opacity: plantee.changeNick.isLoading ? 0.5 : 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "text",
                            name: "nick",
                            placeholder: "Your nick"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "submit",
                            children: locale === "cs" ? "Změnit Přezd\xedvka" : "Change nickname"
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 8688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Box_module_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8774);
/* harmony import */ var _Box_module_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Box_module_sass__WEBPACK_IMPORTED_MODULE_3__);




function Box(props) {
    var _props_marginTop, _props_marginTop1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_Box_module_sass__WEBPACK_IMPORTED_MODULE_3___default().wrapper), props.view === "half" && (_Box_module_sass__WEBPACK_IMPORTED_MODULE_3___default().half), props.posRelative && (_Box_module_sass__WEBPACK_IMPORTED_MODULE_3___default()["view-relative"]), props.largePadding && (_Box_module_sass__WEBPACK_IMPORTED_MODULE_3___default()["view-largePadding"])),
        style: {
            marginTop: "".concat((_props_marginTop = props.marginTop) !== null && _props_marginTop !== void 0 ? _props_marginTop : 0, "px"),
            marginBottom: "".concat((_props_marginTop1 = props.marginTop) !== null && _props_marginTop1 !== void 0 ? _props_marginTop1 : 0, "px")
        },
        children: props.children
    });
}


/***/ }),

/***/ 3637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ Input; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./app/components/Icon.tsx + 36 modules
var Icon = __webpack_require__(3);
// EXTERNAL MODULE: ./app/components/Input.module.sass
var Input_module = __webpack_require__(410);
var Input_module_default = /*#__PURE__*/__webpack_require__.n(Input_module);
// EXTERNAL MODULE: ./app/components/Tooltip.module.sass
var Tooltip_module = __webpack_require__(9679);
var Tooltip_module_default = /*#__PURE__*/__webpack_require__.n(Tooltip_module);
;// CONCATENATED MODULE: ./app/components/Tooltip.tsx



function Tooltip(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Tooltip_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Tooltip_module_default()).icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    name: "questionMark"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Tooltip_module_default()).text,
                children: props.text
            })
        ]
    });
}

;// CONCATENATED MODULE: ./app/components/Input.tsx





const Input = (param)=>{
    let { id , name , type , autoComplete , value , onChange , disabled , readOnly , placeholder , required , iconDecoration , label , reactHookForm , explanation  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Input_module_default()).wrapper, iconDecoration && (Input_module_default()).is_iconDecoration),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel, {
            ...label,
            isRequired: required,
            tooltip: explanation,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (Input_module_default()).inputWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: id,
                        className: (Input_module_default()).input,
                        name: name,
                        type: type,
                        autoComplete: autoComplete,
                        readOnly: readOnly,
                        placeholder: placeholder,
                        value: value,
                        onChange: onChange,
                        disabled: disabled,
                        required: required,
                        ...reactHookForm
                    }),
                    iconDecoration && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Input_module_default()).inputIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            name: iconDecoration
                        })
                    })
                ]
            })
        })
    });
};
const InputLabel = (param)=>{
    let { isLabel , children , isRequired , text , icon , tooltip  } = param;
    if (isLabel) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            className: (Input_module_default()).label,
            children: [
                text && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (Input_module_default()).labelContent,
                    children: [
                        icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Input_module_default()).labelIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                name: icon
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (Input_module_default()).labelName,
                            children: [
                                text,
                                isRequired && "*"
                            ]
                        }),
                        tooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                            text: tooltip
                        })
                    ]
                }),
                children
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};


/***/ }),

/***/ 845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ formDataFromEvent; }
/* harmony export */ });
function formDataFromEvent(e) {
    return Object.fromEntries([
        ...new FormData(e.currentTarget).entries()
    ]);
}


/***/ }),

/***/ 6836:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textButton":"AuthTest_textButton__wncrU"};

/***/ }),

/***/ 8774:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Box_wrapper__QJFOq","view-relative":"Box_view-relative__gfh9_","view-largePadding":"Box_view-largePadding__viwDh"};

/***/ }),

/***/ 410:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__qR45p","is_iconDecoration":"Input_is_iconDecoration__3oofO","input":"Input_input__w76Bs","label":"Input_label__zrlYv","labelContent":"Input_labelContent__jM3Ez","labelIcon":"Input_labelIcon__qfZLN","labelName":"Input_labelName__NWj8M","inputIcon":"Input_inputIcon__fL49m","inputWrapper":"Input_inputWrapper__Z92LX"};

/***/ }),

/***/ 9679:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tooltip_wrapper__dNBJ1","icon":"Tooltip_icon__qJFW_","text":"Tooltip_text__5ExAe"};

/***/ })

}]);